import { useEffect, useState } from "react";
import { EezycoinOffering, getEezycoinOfferings } from "src/apis/eezycoin";
import PageContainer from "src/pages/components/PageContainer";
import { isUserAdministrator } from "src/utils/auth";
import EezycoinOfferingTable from "./components/EezycoinOfferingsTable";
import RegisterFab from "src/pages/components/RegisterFab";

export default function EezycoinOfferingsPage() {
  const [error, setError] = useState<string>("")
  const [offerings, setOfferings] = useState<EezycoinOffering[]>([])

  const fetchData = async (): Promise<void> => {
    try {
      const res = await getEezycoinOfferings();

      setOfferings(res)
      setError('');
    } catch (err: any) {
      setError(err?.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <PageContainer
      title="Ofertas de Eezycoin"
      error={error}
      guard={isUserAdministrator}
    >
      <RegisterFab
        registerUrl="/eezycoin/ofertas/cadastro"
      />
      <EezycoinOfferingTable
        offerings={offerings}
      />
    </PageContainer>
  )
}
